import React, { forwardRef } from 'react';
import { FormInput } from './FormInput';

const FormColorPicker = forwardRef(({ ...props }, ref) => {
    return (
        <FormInput
            ref={ref}
            type="color"
            {...props}
            style={{ ...props.style, height: '50px', padding: '4px' }}
        />
    );
});

FormColorPicker.displayName = 'FormColorPicker';

export { FormColorPicker };
export default FormColorPicker;
